import { render, staticRenderFns } from "./detalleCanje.vue?vue&type=template&id=e28b2966&scoped=true&"
import script from "./detalleCanje.vue?vue&type=script&lang=js&"
export * from "./detalleCanje.vue?vue&type=script&lang=js&"
import style0 from "./detalleCanje.vue?vue&type=style&index=0&id=e28b2966&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28b2966",
  null
  
)

export default component.exports